import styled from "styled-components";

export const TodoDiv = styled.div`
    align-items: center;
    background: #fff;
    color: #000;
    border-radius: 3px;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.15);
    display: flex;
    font-size: 15px;
    justify-content: space-between;
    margin-bottom: 6px;
    padding: 3px 10px;
`;

export const TodoButtonsDiv = styled.div``; 

export const TodoButtons = styled.button`
    background-color: transparent;
    border: none;
    outline: none;
    font-size: 15px;
`;